import { useState } from "react";
import { Modal, Button, Flex, Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import Sider from "antd/es/layout/Sider";
import { useUserInfo } from "GlobalStates/User";
import { tiers } from "Constants";
import { ROUTES } from "Features/Routes/routeConstants";
import { useNavigate } from "react-router-dom";
import { PricingCards } from "Features/Pricing/PricingCards/PricingCards";
import "./styles/profilev2.css";

export const ProfileModal = ({ isModalOpen, setIsModalOpen }) => {
  const { user } = useUserInfo();
  const navigate = useNavigate();
  const [showPricing, setShowPricing] = useState(false);
  const isPhoneSize = window.innerWidth <= 767;
  const handleOk = () => {
    setIsModalOpen(false);
    setShowPricing(false);
  };

  const handleUpgrade = () => {
    setShowPricing(true);
  };

  const handleViewPricing = () => {
    navigate(ROUTES.PRICING);
    setIsModalOpen(false);
    setShowPricing(false);
  };

  return (
    <>
      <Modal
        open={isModalOpen}
        footer={[
          <Button key="ok" type="primary" onClick={handleOk}>
            Okay
          </Button>,
        ]}
        onCancel={handleOk}
        width={isPhoneSize ? "100%" : showPricing ? "80%" : "40%"}
        className="user-profile-modal"
      >
        <Layout className="p-0">
          {(user?.tier === tiers.STARTER || user?.tier === tiers.ACHIEVER) && (
            <Sider
              width={isPhoneSize ? 100 : 200}
              style={{
                background: "#fff",
                padding: "10px",
              }}
            >
              <div
                className={`text-sm font-medium hover:cursor-pointer hover:bg-[#80e280]/10 p-2 hover:text-[#80e280] rounded-lg ${
                  !showPricing && "bg-[#80e280]/10 text-[#80e280]"
                }`}
                onClick={() => setShowPricing(false)}
              >
                Account
              </div>
              <div
                className={`text-sm mt-2 font-medium hover:cursor-pointer hover:bg-[#80e280]/10 p-2 hover:text-[#80e280] rounded-lg ${
                  showPricing && "bg-[#80e280]/10 text-[#80e280]"
                }`}
                onClick={handleUpgrade}
              >
                Upgrade
              </div>
            </Sider>
          )}
          <Content className="bg-white">
            <Flex vertical className="p-4 gap-5 h-full">
              {showPricing ? (
                isPhoneSize ? (
                  <Flex
                    vertical
                    align="center"
                    justify="center"
                    className="w-full h-full"
                  >
                    <Button type="primary" onClick={handleViewPricing}>
                      View Pricing
                    </Button>
                  </Flex>
                ) : (
                  <PricingCards showHeading={false} />
                )
              ) : (
                <>
                  <div>
                    <div className="text-lg font-medium">Account</div>
                    <hr className="border border-gray-100 mt-0" />
                    <Flex align="center" gap={10}>
                      <div className="w-100 h-100">
                        <img
                          src={user?.picture}
                          className="user-icon"
                          alt="user"
                          width={100}
                          height={100}
                          referrerPolicy="no-referrer"
                        />
                      </div>
                      <div className="mt-2 text-base font-medium">
                        {user?.name}
                      </div>
                    </Flex>
                  </div>
                  <div>
                    <div className="text-lg font-medium">Account Details</div>
                    <hr className="border border-gray-100 mt-0" />
                    <Flex vertical>
                      <div className="user-email mt-2 font-medium text-base">
                        Email
                      </div>
                      <div className="user-email text-sm font-medium text-gray-500">
                        {user?.email}
                      </div>
                    </Flex>
                  </div>
                </>
              )}
            </Flex>
          </Content>
        </Layout>
      </Modal>
    </>
  );
};
